let initialState =
{
    rating: -1,
    comment:""
}
const feedback = (state = initialState, action) => {
    switch (action.type) {
        case 'RATING_UPDATED':
            return Object.assign({}, state, {
                rating: action.rating
            })
        case
            'COMMENT_UPDATED':
            return Object.assign({}, state, {
                comment: action.comment
            })
        case "UPDATE_FEEDBACK":
            return { ...state, ...action.feedback };

        default:
            return state;
    }    
}
export default feedback;
